export const AddressENUM = {
   BILLING_ADDRESS_FIELD : 'billing_address',
   SHIPPING_ADDRESS_FIELD : 'shipping_address',
   CARD_FIELD : 'card',
   BILLING_ADDRESS : 'BILLING_ADDRESS',
   SHIPPING_ADDRESS : 'SHIPPING_ADDRESS',
   CARD : 'CARD',
   ZIP : 'zip',
   BILLING_ZIP : 'billing_zip',
   STATE_CODE : 'state_code'
}

export function AddressValidator(getters,value,country, fname) {
    const addresses = getters.addresses;
    let temporaryState = [];
    let errorMessageToBeSet="";
    switch (fname) {
        case AddressENUM.BILLING_ADDRESS_FIELD:
        case AddressENUM.SHIPPING_ADDRESS_FIELD:
          temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.BILLING_ADDRESS);
          if (
            getters.field_config(AddressENUM.SHIPPING_ADDRESS_FIELD, "shipping.ship.to.billing") &&
            getters.field_config(AddressENUM.SHIPPING_ADDRESS_FIELD, "shipping.ship.to.billing").value
          ) {
                temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.BILLING_ADDRESS);
                const isRestricted = checkRestrictions(temporaryState, value, country);
            if (isRestricted) {
                errorMessageToBeSet = getters.get_text("error.column.region.restrict_billing_zip");
            } else {
                temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.SHIPPING_ADDRESS);
                const isRestricted = checkRestrictions(temporaryState, value, country);
                if (isRestricted) {
                    errorMessageToBeSet = getters.get_text("error.column.region.restrict_shipping_zip");
                }
            }
          } else {
                switch (fname) {
                    case AddressENUM.BILLING_ADDRESS_FIELD:
                        temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.BILLING_ADDRESS);
                        const isBillingRestricted = checkRestrictions(temporaryState, value, country);
                        if (isBillingRestricted) {
                        errorMessageToBeSet = getters.get_text("error.column.region.restrict_billing_zip");
                        }
                        break;
            
                    case AddressENUM.SHIPPING_ADDRESS_FIELD:
                        temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.SHIPPING_ADDRESS);
                        const isShippingRestricted = checkRestrictions(temporaryState, value, country);
                        if (isShippingRestricted) {
                        errorMessageToBeSet = getters.get_text("error.column.region.restrict_shipping_zip");
                        }
                        break;
                    default:
                        break;    
                }
          }
          break;
      
        case AddressENUM.CARD_FIELD:
          temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.CARD);
          const isCardRestricted = checkRestrictions(temporaryState, value, country);
          if (isCardRestricted) {
            errorMessageToBeSet = getters.get_text("error.column.region.restrict_card_zip");
          }
          break;
      
        default:
          break;
    }   
    return errorMessageToBeSet;
}

function checkRestrictions(temporaryState, value, country) {
    const restrictedCountry = temporaryState && temporaryState[0]?.countries.find((list) => list.country_code === country);
    const {allowed_regions, blocked_regions} = restrictedCountry || {};
    if(allowed_regions){
        if (allowed_regions?.zip.includes(value)) {
            return false;  
        }else{
            return true;
        }
    }else{
        if (blocked_regions?.zip.includes(value)) {
            return true; 
        }else{
            return false;
        }
    }
}
export function AddressValidatorState(getters,value,country, fname) {
    const addresses = getters.addresses;
    let temporaryState = [];
    let errorMessageToBeSet="";
    switch (fname) {
        case AddressENUM.BILLING_ADDRESS_FIELD:
        case AddressENUM.SHIPPING_ADDRESS_FIELD:
          temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.BILLING_ADDRESS);
          if (
            getters.field_config(AddressENUM.SHIPPING_ADDRESS_FIELD, "shipping.ship.to.billing") &&
            getters.field_config(AddressENUM.SHIPPING_ADDRESS_FIELD, "shipping.ship.to.billing").value
          ) {
            temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.BILLING_ADDRESS);
            const isRestricted = checkRestrictionsState(temporaryState, value, country);
            if (isRestricted) {
              errorMessageToBeSet = getters.get_text("error.column.region.restrict_billing_state");
            } else {
              temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.SHIPPING_ADDRESS);
              const isRestricted = checkRestrictionsState(temporaryState, value, country);
              if (isRestricted) {
                errorMessageToBeSet = getters.get_text("error.column.region.restrict_shipping_state");
              }
            }
          } else {
            switch (fname) {
              case AddressENUM.BILLING_ADDRESS_FIELD:
                temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.BILLING_ADDRESS);
                const isBillingRestricted = checkRestrictionsState(temporaryState, value, country);
                if (isBillingRestricted) {
                  errorMessageToBeSet = getters.get_text("error.column.region.restrict_billing_state");
                }
                break;
      
              case AddressENUM.SHIPPING_ADDRESS_FIELD:
                temporaryState = addresses?.filter(address => address?.address_type === AddressENUM.SHIPPING_ADDRESS);
                const isShippingRestricted = checkRestrictionsState(temporaryState, value, country);
                if (isShippingRestricted) {
                  errorMessageToBeSet = getters.get_text("error.column.region.restrict_shipping_state");
                }
                break;
            }
          }
          break;
      
        default:
          break;
      }         
    return errorMessageToBeSet;
}
function checkRestrictionsState(temporaryState, value, country) {
    const restrictedCountry = temporaryState && temporaryState[0]?.countries.find((list) => list.country_code === country);
    const {allowed_regions, blocked_regions} = restrictedCountry || {};
    if(allowed_regions){
        if (allowed_regions?.state_code?.includes(value)) {
            return false;  
        }else{
            return true;
        }
    }else{
        if (blocked_regions?.state_code?.includes(value)) {
            return true; 
        }else{
            return false;
        }
    }
}

